export enum OrderTifEnum {
  Day = 1,
  OCO = 2,
  None = 255,
}
